export default {
	properties: [
		{
			text: 'Nombre',
			key: 'nombre',
			type: 'text',
			value: '',
		},
	],
	singular_model_name_spanish: 'Posible Causa',
	plural_model_name_spanish: 'Posibles Causas',
	create_model_name_spanish: 'Nueva',
	text_delete: 'la',
}